<template>
  <div class="checkout-review">
    <v-container
      fluid
      class="checkout-review-header"
    >
      <v-row
        align-content="space-between"
        no-gutters
      >
        <v-col>
          <span class="checkout-review-heading">
            {{ heading }}
          </span>
        </v-col>
        <v-col>
          <span class="checkout-review-total">
            {{ `${$t('header-cart-item-count')} (${cartItems.length})` }}
          </span>
        </v-col>
      </v-row>
    </v-container>

    <reward-lists :item-groups="cartItemGroups" />

    <v-container
      fluid
      class="mt-3"
    >
      <v-row class="checkout-review-total">
        <v-col
          cols="2"
          class="checkout-review-total-label"
        >
          {{ $t('complete-total') }}:
        </v-col>
        <v-col
          cols="10"
          class="checkout-review-total-total svp-font-weight-medium"
        >
          {{ $money(cartTotal, currencyCode) }}
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  GET_CURRENCY_CODE,
  GET_CART_TOTAL,
  GET_CART_ITEMS,
  GET_PHYSICAL_CART_ITEMS,
  GET_ELECTRONIC_CART_ITEMS
} from '../../store/get-types'
import RewardLists from './RewardLists.vue'

export default {
  name: 'CheckoutReview',
  components: {
    RewardLists
  },
  props: {
    heading: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      currencyCode: GET_CURRENCY_CODE,
      cartTotal: GET_CART_TOTAL,
      cartItems: GET_CART_ITEMS,
      physicalCartItems: GET_PHYSICAL_CART_ITEMS,
      digitalCartItems: GET_ELECTRONIC_CART_ITEMS
    }),
    cartItemGroups () {
      const { physicalCartItems, digitalCartItems, $t } = this
      const cartItemGroups = [
        {
          key: 'physical',
          label: $t('checkoutReview.deliveryTypeHeadings.physical'),
          items: physicalCartItems
        },
        {
          key: 'digital',
          label: $t('checkoutReview.deliveryTypeHeadings.digital'),
          items: digitalCartItems
        }
      ]

      return cartItemGroups.filter(({ items }) => items.length > 0)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/scss/variables';

.checkout-review-header {
  padding: 0 0 10px 0;

  .checkout-review-heading {
    font-size: 20px;
  }
  .checkout-review-total {
    display: block;
    text-align: right;
    color: map-get($grey, 'darken-2');
  }
}
</style>
